import { axios } from "../axiosInstance";

export interface DealmakerCard {
  dealId: number;
  firmId: number;
  title: string;
  companyName: string;
  companyType: string;
  companyNameSlug: string;
  logoName: string;
  placeLabel: string;
  dateLabel: string;
  excerpt: string;
  dealCount: number;
}

export interface DealmakerOption {
  id: string;
  name: string;
}

export interface DealmakerChoice {
  value: string;
  label: string;
}

export interface DealmakerCatalogResult {
  active: { items: DealmakerCard[]; page: number; pageCount: number; total: number };
  archived: { items: DealmakerCard[]; page: number; pageCount: number; total: number };
  options: {
    firms: DealmakerOption[];
    jurisdictions: DealmakerChoice[];
    regions: DealmakerChoice[];
    industries: DealmakerOption[];
    dealTypes: DealmakerOption[];
  };
}

export interface DealmakerDetail {
  dealId: number;
  firmId: number;
  title: string;
  companyName: string;
  logoName: string;
  description: string;
  additionalInfo: string;
  placeLabel: string;
  location: string;
  regionName: string;
  dealType: string;
  dealValue: string;
  governingLaw: string;
  industries: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  contactId: number;
  contactSlug: string;
}

export interface DealmakerActor {
  contactId: string;
  companyId: string;
  name: string;
  email: string;
  phone: string;
  firmName: string;
  title: string;
}

export interface DealmakerContactResult {
  saved: boolean;
  errors?: string[];
}

function queryString(params: Record<string, string>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      search.set(key, value);
    }
  });
  const text = search.toString();
  return text ? `?${text}` : "";
}

export async function getDealmakerCatalog(params: Record<string, string>): Promise<DealmakerCatalogResult> {
  const response = await axios.Get(`./dealmakerCatalog${queryString({ view: "catalog", ...params })}`);
  return response.data as DealmakerCatalogResult;
}

export async function getDealmakerDeal(dealId: string, countView: boolean): Promise<DealmakerDetail> {
  const response = await axios.Get(`./dealmakerCatalog${queryString({ view: "deal", dealId, countView: countView ? "1" : "" })}`);
  return response.data as DealmakerDetail;
}

export async function getFirmArchivedDeals(firmId: string, excludeDealId: string): Promise<DealmakerCard[]> {
  const response = await axios.Get(`./dealmakerCatalog${queryString({ view: "firmDeals", firmId, excludeDealId })}`);
  return response.data as DealmakerCard[];
}

export async function recordDealmakerVisit(actor: DealmakerActor): Promise<void> {
  await axios.Post("./dealmakerCatalog", { action: "visit", ...actor });
}

export async function submitDealmakerContact(actor: DealmakerActor, dealId: string, comment: string, method: string): Promise<DealmakerContactResult> {
  const response = await axios.Post("./dealmakerCatalog", {
    action: "contact",
    ...actor,
    dealId,
    comment,
    method,
  });
  return response.data as DealmakerContactResult;
}
